export const SYLLABUS_MODE = {
  TRADITIONAL: 'TRADITIONAL',
  TUNGKAI: 'TUNGKAI',
};
